export type PricingWindowKey = "earlyBird" | "standard" | "onSite";

export type MembershipTier =
  | "ieee_student_life_retired"
  | "ieee_member"
  | "non_ieee_member";

export interface EventPricingConfig {
  earlyBird: { endsAt: string };
  standard: { endsAt: string };
  onSite: { endsAt: string | null };
  fullConferenceRatesUsd: Record<
    MembershipTier,
    Record<PricingWindowKey, number>
  >;
}

export const MEMBERSHIP_TIER_LABELS: Record<MembershipTier, string> = {
  ieee_student_life_retired: "IEEE Student / Life / Retired",
  ieee_member: "IEEE Member",
  non_ieee_member: "Non-IEEE Member",
};

export const MEMBERSHIP_TIERS: MembershipTier[] = [
  "ieee_student_life_retired",
  "ieee_member",
  "non_ieee_member",
];

export const PRICING_WINDOWS: { key: PricingWindowKey; label: string }[] = [
  { key: "earlyBird", label: "Early bird" },
  { key: "standard", label: "Standard" },
  { key: "onSite", label: "On-site" },
];

const zeroRates = (): Record<PricingWindowKey, number> => ({
  earlyBird: 0,
  standard: 0,
  onSite: 0,
});

export function defaultPricingConfig(eventStartIso: string): EventPricingConfig {
  const start = new Date(eventStartIso);
  const earlyBirdEnd = new Date(start);
  earlyBirdEnd.setDate(earlyBirdEnd.getDate() - 90);
  const standardEnd = new Date(start);
  standardEnd.setDate(standardEnd.getDate() - 30);

  return {
    earlyBird: { endsAt: earlyBirdEnd.toISOString() },
    standard: { endsAt: standardEnd.toISOString() },
    onSite: { endsAt: null },
    fullConferenceRatesUsd: {
      ieee_student_life_retired: zeroRates(),
      ieee_member: zeroRates(),
      non_ieee_member: zeroRates(),
    },
  };
}

export function parsePricingConfig(raw: unknown): EventPricingConfig | null {
  if (!raw || typeof raw !== "object") return null;
  return raw as EventPricingConfig;
}
